export default "__VITE_ASSET__O$Csi9sQ__"